<!-- filepath: src/views/payment/PaymentMethodList.vue -->
<template>
  <div class="payment-methodList-view">
  
     
      <div class="payment-method-list-page">
        <h2 class="buy-now-title">{{ t('payment.title') }}</h2>
        <div class="card-list">
          <div
            class="card-item"
            :class="{ selected: idx === 0 }"
            v-for="(card, idx) in cardList"
            :key="idx"
          >
            <div class="card-row">
               <span class="card-expired">
                <span class="expired-icon">&#9888;</span>
                <span class="expired-text">Expired {{ card.expiryDate }}</span>
              </span>
            </div>
            <div class="card-row card-info">
              <img class="card-logo" :src="getCardLogo(card.cardBank)" alt="Card" />
             <span class="card-dots">{{ formatCardNumber(card.cardNumber) }}</span>
            </div>
            <div class="card-row card-name">{{ card.cardHolder }} </div>
            <div class="card-row card-address">{{ card.defaultAddress }}</div>
            <div class="card-row card-address">{{ card.city }}, {{ card.province }} {{ card.postalCode }}</div>
            <div class="card-row card-actions">
              <el-button
                v-if="card.isDefault !== 1"
                type="warning"
                size="small"
                @click="setDefaultCard(card.id)"
                style="margin-left: 8px;"
                plain
              >
                设为默认
              </el-button>
              <el-tag
                v-else
                type="success"
                size="small"
                style="margin-left: 8px;"
              >
                默认
              </el-tag>
              <el-button
                type="danger"
                size="small"
                @click="deleteCard(idx)"
                style="margin-left: 8px;"
                plain
              >
                删除
              </el-button>
            </div>
          </div>
          <router-link to="/payment/add" class="card-item add-card">
            <div class="add-plus">+</div>
            <div>
              <span class="add-link">Add Payment Method</span>
            </div>
          </router-link>
        </div>
        <div class="footer-links">
          <a href="#">Terms of Use</a>
          <span>|</span>
          <a href="#">Privacy & Security</a>
        </div>
      </div>
    </div>
  
</template>

<script setup>
import { ref, onMounted } from 'vue'
import AccountSidebar from '@/views/PersonCenter/AccountSidebar.vue'
import { useI18n } from 'vue-i18n'
import { PayMethodList ,PayMethodDelete, PayMethodDefault} from '@/api/payMethod'
import { getUserId } from '@/services/userInfo'
import { ElLoading, ElMessage, ElButton, ElTag } from 'element-plus'

const { t } = useI18n()
const cardList = ref([]) 



onMounted(fetchList)


async function fetchList() {
  const loadingInstance = ElLoading.service({
    lock: true,
    text: "",
    background: 'rgba(255,255,255,0.7)'
  })
  try {
    const res = await PayMethodList({ userId: getUserId() })
    console.log('Payment methods fetched:', res.data)
    if (res.code === 200 && Array.isArray(res.data)) {
      cardList.value = res.data
    } else {
      cardList.value = []
    }
  } catch (e) {
    cardList.value = []
  } finally {
    loadingInstance.close()
  }
}

function formatCardNumber(cardNumber) {
  if (!cardNumber) return '**** **** **** ****';
  return cardNumber.replace(/^(\d{4})\d*(\d{4})$/, '$1 **** **** $2');
}

async function deleteCard(idx) {
 const card = cardList.value[idx]
  if (!card || !card.id) return
  const loadingInstance = ElLoading.service({
    lock: true,
    text: t('payment.deleting') ,
    background: 'rgba(255,255,255,0.7)'
  })
  console.log(`Deleting card: ${card.id}`)
  try {
    const res = await PayMethodDelete(card.id)
    if (res.code === 200) {
      ElMessage.success(t('payment.deleteSuccess') || '删除成功')
      await fetchList() // 重新获取列表
    } else {
      ElMessage.error(res.msg || t('payment.deleteFailed') || '删除失败')
    }
  } catch (e) {
    ElMessage.error(t('payment.deleteFailed') || '删除失败')
  } finally {
    loadingInstance.close()
  }
}

async function setDefaultCard(id) {
  const loadingInstance = ElLoading.service({
    lock: true,
    text: '',
    background: 'rgba(255,255,255,0.7)'
  })
  try {
    const res = await PayMethodDefault(id)
    if (res.code === 200) {
      ElMessage.success(t('payment.setDefaultSuccess') )
      await fetchList()
    } else {
      ElMessage.error(res.msg || t('payment.setDefaultFailed') )
    }
  } catch (e) {
    ElMessage.error(t('payment.setDefaultFailed') )
  } finally {
    loadingInstance.close()
  }
}

function getCardLogo(type) {
  if (type === 'visa') return 'https://img.icons8.com/color/32/000000/visa.png'
  if (type === 'mastercard') return 'https://img.icons8.com/color/32/000000/mastercard.png'
  if (type === 'amex') return 'https://img.icons8.com/color/32/000000/amex.png'
  return ''
}


</script>

<style scoped>
.card-dots {
  font-size: 2px; /* 调整字体大小 */
  
  color: #333; /* 设置深灰色字体 */
  
  display: inline-block; /* 让样式更紧凑 */
}

.payment-methodList-view {
  background-color: #f5f7fa;
  min-height: 100vh;
  color: #333;
  padding-bottom: 40px;
}
.center-layout {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  max-width: 1100px;
  margin: 0 auto;
  gap: 18px;
  padding-top: 18px;
}
.account-layout {
  min-width: 200px;
}
.payment-method-list-page {
  flex: 1;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  padding: 32px 40px;
  min-width: 400px;
  width: 100%;
  overflow-y: auto;
  max-height: 80vh;
  padding: 24px;
 
}
h2 {
  font-size: 2em;
  font-weight: bold;
  color: #222;
  margin-bottom: 24px;
  padding-left: 0;
}
.card-list {
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
}
.card-item {
  flex: 1 1 calc(50% - 16px);
  max-width: calc(50% - 16px);
  min-width: 320px;
  box-sizing: border-box;
  min-height: 210px;
  border: 1.5px solid #eee;
  border-radius: 4px;
  background: #fff;
  padding: 20px 24px 16px 10px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.card-item.selected {
  border: 1.5px solid orange;
}
.card-row {
  margin-bottom: 8px;
  font-size: 1em;
  color: #333;
  text-align: left;
  padding-left: 5px;
}
.card-actions {
  margin-top: 8px; /* 增加与上方内容的间距 */
  text-align: left; /* 确保内容左对齐 */
}

.card-info {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.card-logo {
  height: 24px;
  width: auto;
}
.card-dots {
  font-size: 1.5em;
  color: #888;
  margin-left: 4px;
}
.card-expired {
  display: flex;
  align-items: center;
  color: #d94a00;
  font-size: 1em;
  margin-left: 12px;
}
.expired-icon {
  font-size: 1.2em;
  margin-right: 4px;
}
.card-name {
  font-weight: 500;
  margin-bottom: 2px;
}
.card-address {
  color: #444;
  font-size: 0.98em;
  margin-bottom: 2px;
}
.default {
  color: #444;
  font-size: 1em;
}
.delete-link {
  color: #fb6e01;
  text-decoration: underline;
  font-size: 1em;
  cursor: pointer;
}
.add-card {
  border: 1.5px dashed #bbb;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fb6e01;
  cursor: pointer;
  min-height: 210px;
  transition: border-color 0.2s;
}
.add-card:hover {
  border-color: #fb6e01;
}
.add-plus {
  font-size: 3em;
  font-weight: 400;
  color: #222;
  margin-bottom: 8px;
}
.add-link {
  color: #fb6e01;
  font-size: 1.1em;
  text-decoration: underline;
  cursor: pointer;
}
.footer-links {
  margin: 18px 0 0 8px;
  font-size: 0.98em;
}
.footer-links a {
  color: #222;
  text-decoration: underline;
  margin: 0 4px;
}
.footer-links span {
  color: #888;
  margin: 0 4px;
}
@media (max-width: 800px) {
  .center-layout {
    flex-direction: column;
    gap: 0;
  }
  .account-layout {
    margin-top: 20px;
    margin-left: 0;
    min-width: 0;
    margin-bottom: 16px;
  }
  .payment-method-list-page {
    width: 100%;
    min-width: 0;
    padding: 12px 10px;
    border-radius: 10px;
    box-sizing: border-box;
    margin-left: 0;
    margin-right: 0;
  }
  .card-list {
    gap: 12px;
    max-height: none;
    flex-direction: column;
    width: 100%;
  }
  .card-item, .add-card {
    flex: 1 1 100%;
    max-width: 100%;
    min-width: 0;
    margin-bottom: 0;
    padding: 16px 8px 12px 10px;
  }
  .payment-methodList-view {
    padding-left: 10px;
    padding-right: 10px;
  }
}
</style>